import { Routes } from '@angular/router';
import { SubstantiationComponent } from './pages/enter-claims-la/substantiation/substantiation.component';
import { MsalGuard } from '@azure/msal-angular';
import { IraResultComponent } from './pages/ira-result/ira-result.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'home',
    // title: 'Home',
    loadComponent: () =>
      import('./pages/enter-claims-la/home/home.component').then(
        (m) => m.HomeComponent
      ),
    canActivate: [MsalGuard],
    // breadcrumb: 'Home',
  },
  {
    path: 'preview',
    // title: 'Preview',
    loadComponent: () =>
      import('./pages/enter-claims-la/preview/preview.component').then(
        (m) => m.PreviewComponent
      ),
    // breadcrumb: 'Preview',
  },
  {
    path: 'result',
    // title: 'Result',
    loadComponent: () =>
      import('./pages/enter-claims-la/result/result.component').then(
        (m) => m.ResultComponent
      ),
    // children: [{ path: 'substantiation', component: SubstantiationComponent }],
    children: [
      { path: 'ira-result', component: IraResultComponent },
      { path: 'substantiation', component: SubstantiationComponent },
    ],
  },

  {
    path: 'confirmation',
    // title: 'Confirmation',
    loadComponent: () =>
      import(
        './pages/enter-claims-la/confirmation/confirmation.component'
      ).then((m) => m.ConfirmationComponent),
  },

  {
    path: 'substantiation-confirmation',
    // title: 'SubstantiationConfirmation',
    loadComponent: () =>
      import(
        './pages/enter-claims-la/substantiation/substantiation-confirmation/substantiation-confirmation.component'
      ).then((m) => m.SubstantiationConfirmationComponent),
  },

  {
    path: 'ira-confirmation',
    // title: 'IRAConfirmation',
    loadComponent: () =>
      import(
        './pages/enter-claims-la/ira-confirmation/ira-confirmation.component'
      ).then((m) => m.IraConfirmationComponent),
  },

  {
    path: 'editclaims',
    // title: 'Editclaims',
    loadComponent: () =>
      import('./pages/edit-claims/edit-claims/edit-claims.component').then(
        (m) => m.EditClaimsComponent
      ),
  },

  {
    path: 'ira',
    // title: 'ira',
    loadComponent: () =>
      import('./pages/ira-route/ira-route.component').then(
        (m) => m.IraRouteComponent
      ),
  },

  // {
  //   path: 'ira',
  //   title: 'ira',
  //   loadComponent: () =>
  //     import('./pages/ira-result/ira-result.component').then(
  //       (m) => m.IraResultComponent
  //     ),
  //   // breadcrumb: 'Preview',
  // },
  // {
  //   path: 'substantiation',
  //   title: 'Substantiation',
  //   loadComponent: () =>
  //     import(
  //       './pages/enter-claims-la/substantiation/substantiation.component'
  //     ).then((m) => m.SubstantiationComponent),
  //   // breadcrumb: 'Home',
  // },
];
